import React, { useEffect } from "react";
import "../../../../../Assets/Styles/ChatMessages.scss";
import Candidates from "./Candidates";

const ChatMessages = (props) => {
  useEffect(() => {
    setTimeout(() => {
      scrollConversation();
    }, 400);
  }, [
    props.ConverstionMessages,
    props.showCandidates,
    props.isJpa,
    props.Recommendations,
  ]);

  const scrollConversation = () => {
    if (document.getElementById("message-items") !== null) {
      let ScrollHeight = document.getElementById(
        "conversation-wrapper"
      ).scrollHeight;
      document.getElementById("conversation-wrapper").scrollTop = ScrollHeight;
    }
  };

  const handleIsMeChatBobbleClassName = (Index) => {
    if (Index === 0) {
      return "message-holder is-me radioused-right";
    } else if (
      props.ConversationMessages &&
      Index > 0 &&
      props.ConversationMessages[Index - 1].senderId !== props.UserInfo.id
    ) {
      return "message-holder is-me radioused-right";
    } else {
      return "message-holder is-me";
    }
  };

  const handleChatBobbleClassName = (Index) => {
    if (Index === 0) {
      return "message-holder radioused-left";
    } else if (
      props.ConversationMessages &&
      Index > 0 &&
      props.ConversationMessages[Index - 1].senderId === props.UserInfo.id
    ) {
      return "message-holder radioused-left";
    } else {
      return "message-holder";
    }
  };

  const displayMessageTime = (Time) => {
    return new Date(Time).getHours() + ":" + new Date(Time).getMinutes();
  };

  return (
    <div className="messages">
      <div
        className="conversation-wrapper"
        id="conversation-wrapper"
        onScroll={() => props.handleResetTimeout()}
      >
        <div className="message-items" id="message-items">
          {props.ConverstionMessages.map((item, idx) => (
            <>
              {item.content !== "" ? (
                <div key={idx} className="message-row">
                  <>
                    <div
                      className={
                        item.isMe
                          ? handleIsMeChatBobbleClassName(idx)
                          : handleChatBobbleClassName(idx)
                      }
                    >
                      <section className="message-content">
                        {item.isTemp && props.XIsShown ? (
                          <i
                            className="feather-x"
                            onClick={() => props.RemoveOption(item.content)}
                          ></i>
                        ) : null}
                        {item.content}
                      </section>
                      <p className="message-info">
                        {displayMessageTime(
                          item.dateTime ? item.dateTime : new Date().getTime()
                        )}
                      </p>
                    </div>
                  </>
                </div>
              ) : null}
            </>
          ))}
          {props.showCandidates ? (
            <Candidates
              candidateList={props.candidateList}
              savedContents={props.savedContents}
              isJpa={props.isJpa}
              Recommendations={props.Recommendations}
              handleJpaSave={props.handleJpaSave}
              handleJpaApply={props.handleJpaApply}
              handleJpaMoreDetail={props.handleJpaMoreDetail}
              JPAType={props.JPAType}
              JPACategoryType={props.JPACategoryType}
              RefreshRecommendations={() => props.RefreshRecommendations()}
              UniqueTitles={props.UniqueTitles}
              LangData={props.LangData}
              SetDetailsIsOpen={(Bool, JPAItem) =>
                props.SetDetailsIsOpen(Bool, JPAItem)
              }
              ChangedCandidateBookmark={props.ChangedCandidateBookmark}
              ChangedJPAReaction={props.ChangedJPAReaction}
              SavedRequestId={props.SavedRequestId}
              ShowError={(bool) => props.ShowError(bool)}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ChatMessages;
